<template>
    <div>
      <button type="button" v-on:click="copy">{{ label }}</button>
    </div>
</template>

<script>
export default {
  name: 'CopyButton',
  props: {
    label: {
      type: String,
      default: 'Button',
    },
    selector: String,
  },
  methods: {
    copy() {
      // get the text to copy
      const texts = [];
      const copyElements = document.querySelectorAll(`${this.selector} *`);
      copyElements.forEach(element => texts.push(element.textContent));

      // create and insert the text area with the text to copy
      const textarea = document.createElement('textarea');
      textarea.value = texts.join('\n');
      document.querySelector('BODY').appendChild(textarea);

      // select and copy the contents
      textarea.select();
      document.execCommand('copy');

      // delete the element
      textarea.remove();
    },
  },
};
</script>

<style scoped>
</style>
